import { useState } from "react";

export function useExpensesData(supabase, landlordId, reload) {
  const [expenses, setExpenses] = useState([]);
  const [showAddExpense, setShowAddExpense] = useState(false);
  const [newExpense, setNewExpense] = useState({ date: "", category: "Insurance", description: "", amount: "", property_id: null });

  const addExpense = async () => {
    if (!newExpense.description) return;
    setShowAddExpense(false);
    let receipt_url = null;
    if (newExpense.receiptFile) {
      const file = newExpense.receiptFile;
      const fileName = `${Date.now()}-${file.name.replace(/\s/g, "_")}`;
      const { data, error: uploadError } = await supabase.storage.from("receipts").upload(fileName, file);
      if (!uploadError) {
        const { data: urlData } = supabase.storage.from("receipts").getPublicUrl(fileName);
        receipt_url = urlData.publicUrl;
      }
    }
    const { error } = await supabase.from("expenses").insert([{
      date: newExpense.date || null, category: newExpense.category,
      description: newExpense.description,
      amount: newExpense.amount ? Math.round(parseFloat(newExpense.amount)) : null,
      property_id: newExpense.property_id || null,
      receipt_url, user_id: landlordId,
    }]);
    if (error) { alert("Error: " + error.message); return; }
    setNewExpense({ date: "", category: "Insurance", description: "", amount: "", property_id: null, receiptFile: null });
    reload();
  };

  const deleteExpense = async (id) => {
    if (!window.confirm("Delete this expense?")) return;
    await supabase.from("expenses").delete().eq("id", id);
    reload();
  };

  return {
    expenses, setExpenses,
    showAddExpense, setShowAddExpense,
    newExpense, setNewExpense,
    addExpense, deleteExpense,
  };
}
